export enum ROUTES {
  ACTIVATION_LINK = '/purchase/connect/:token',
  ALREADY_PAYING = '/already_paying',
  BILLING_DETAILS = '/billing_details',
  CATEGORIES_FALLBACK = '/categories/*',
  CONFIRMATION = '/confirmation',
  CONFIRMATION_UNKNOWN = '/confirmation/unknown',
  CONTACT = '/contact',
  GOTHAER_SHORT = '/gothaer',
  GOTHAER = '/krankenkasse/gothaer',
  GROUPS_FALLBACK = '/groups/*',
  HOME = '/',
  IMPRINT = '/imprint',
  LOGIN_CONFIRMATION = '/login/:token',
  PAYMENT_ERROR = '/payment_error',
  PAYMENT_METHOD = '/payment_method',
  PRICING = '/pricing',
  PRIVACY = '/privacy',
  RESEND_TOKEN = '/resend_token/',
  RESEND_TOKEN_B2B = '/resend_token/b2b',
  SLEEP_FALLBACK = '/open/sleep/*',
  SUMMARY = '/summary',
  TERMINATE = '/terminate',
  TERMINATE_SUCCESS = '/terminate/success',
  TERMS = '/terms',
  VOUCHER_LANDINGPAGE = '/voucher',
  VOUCHER_SUCCESS = '/voucher_success',
  XING_PREMIUM = '/xing-premium',
  XING_PRO_JOBS = '/xing-projobs',
  BOILERPLATE_INSURANCE_COOPERATION_PAGE = '/sample-kooperation',
  ZPP_LANDING_PAGE = '/krankenkasse',
  AOK_BAYERN_LANDING_PAGE = '/krankenkasse/aok-bayern',
  AOK_NORDOST_LANDING_PAGE = '/krankenkasse/aoknordost',
  AOK_NORDOST_CUSTOM = '/krankenkasse/AOKNordost',
  TRUST_PORTAL = '/security',
  SALUS_BKK_LANDING_PAGE = '/krankenkasse/salus-bkk',
  VIACTIV_LANDING_PAGE = '/krankenkasse/viactiv',
  VIVIDA_BKK_LANDING_PAGE = '/krankenkasse/vividabkk',
  IKK_CLASSIC_LANDING_PAGE = '/krankenkasse/ikkclassic',
  MKK_LANDING_PAGE = '/krankenkasse/meine-krankenkasse',
  BIG_DIRECT_LANDING_PAGE = '/krankenkasse/bigdirektgesund',
  AOK_BREMEN_LANDING_PAGE = '/krankenkasse/aokbremen',
}
